/* PTB — Packs : sélecteur de quantité dégressif sur la fiche produit.
   Barème : 1 article = prix normal · 2 = -10 % (le plus populaire) · 3 = -20 % (Best pack), 3 articles maximum.
   Les remises réelles sont des remises automatiques Shopify « PACK » (produits tagués pack_offre) ;
   ce script affiche le prix attendu et ajoute en une fois les N articles choisis au panier. */
(function () {
  "use strict";

  var STR = {
    fr: {
      legend: "CHOISIR : PACK",
      one: "1 article", many: "{n} articles",
      save: "Tu économises {amount}",
      popular: "Le plus populaire", best: "Best pack",
      hint: "Couleur, taille",
      mine: "ta sélection ci-dessus",
      color: "Couleur", size: "Taille",
      add: "Ajouter le pack ({n} articles) au panier",
      error: "Impossible d'ajouter ces articles. Réessaie."
    },
    en: {
      legend: "CHOOSE: PACK",
      one: "1 item", many: "{n} items",
      save: "You save {amount}",
      popular: "Most popular", best: "Best pack",
      hint: "Color, size",
      mine: "your selection above",
      color: "Color", size: "Size",
      add: "Add pack ({n} items) to cart",
      error: "Couldn't add these items. Please try again."
    },
    ar: {
      legend: "اختر: الباقة",
      one: "قطعة واحدة", two: "قطعتان", many: "{n} قطع",
      save: "توفّر {amount}",
      popular: "الأكثر رواجًا", best: "أفضل باقة",
      hint: "اللون، المقاس",
      mine: "اختيارك أعلاه",
      color: "اللون", size: "المقاس",
      add: "أضف الباقة ({n} قطع) إلى السلة",
      error: "تعذّرت إضافة هذه القطع. حاول مرة أخرى."
    }
  };

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function init() {
    var root = document.querySelector("[data-ptb-product-root]");
    var mount = root && root.querySelector("[data-ptb-pack]");
    var dataNode = root && root.querySelector("[data-ptb-product-variants]");
    if (!mount || !dataNode || mount.getAttribute("data-ready")) return;

    var variants;
    try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var lang = (document.documentElement.lang || "fr").toLowerCase().slice(0, 2);
    var T = STR[lang] || STR.fr;
    var tiers;
    try { tiers = JSON.parse(mount.getAttribute("data-tiers")); } catch (e2) { tiers = null; }
    if (!Array.isArray(tiers) || !tiers.length) tiers = [[1, 0], [2, 10, "popular"], [3, 20, "best"]];
    var maxQty = tiers[tiers.length - 1][0];

    var currency = root.getAttribute("data-currency") || "EUR";
    var locale = lang === "en" ? "en-GB" : "fr-FR";
    var colorIndex = Number(root.getAttribute("data-color-index") || 0);
    var sizeIndex = Number(root.getAttribute("data-size-index") || 1);
    var hasColor = root.querySelectorAll("[data-ptb-color]").length > 0;
    var hasSize = root.querySelectorAll("[data-ptb-size]").length > 0;
    var variantInput = root.querySelector("[data-ptb-variant-id]");
    var addBtn = root.querySelector("[data-ptb-add]");
    var form = addBtn && addBtn.closest ? addBtn.closest("form") : null;
    var shop = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";

    function money(cents) {
      return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(Number(cents || 0) / 100);
    }
    function qtyLabel(n) {
      if (n === 1) return T.one;
      if (n === 2 && T.two) return T.two;
      return T.many.replace("{n}", String(n));
    }
    function usable(v) { return Boolean(v && v.id && v.available !== false); }
    function uniq(index) {
      var out = [];
      variants.forEach(function (v) {
        var value = v.options ? v.options[index] : null;
        if (value !== null && value !== undefined && out.indexOf(value) < 0) out.push(value);
      });
      return out;
    }
    var colors = hasColor ? uniq(colorIndex) : [];
    var sizes = hasSize ? uniq(sizeIndex) : [];
    var needsRows = hasColor || hasSize;
    var hintText = hasColor && hasSize ? T.hint : (hasColor ? T.color : T.size);

    function variantFor(color, size) {
      return variants.find(function (v) {
        return usable(v) && (!hasColor || v.options[colorIndex] === color) && (!hasSize || v.options[sizeIndex] === size);
      }) || null;
    }
    function sizesFor(color) {
      return sizes.filter(function (s) { return variantFor(color, s); });
    }
    function mainVariant() {
      var id = variantInput ? String(variantInput.value) : "";
      return variants.find(function (v) { return String(v.id) === id; }) || null;
    }
    function pctFor(qty) {
      var pct = 0;
      tiers.forEach(function (t) { if (qty >= t[0]) pct = t[1]; });
      return pct;
    }
    function totals(list, pct) {
      var groups = {};
      list.forEach(function (v) {
        if (!groups[v.id]) groups[v.id] = { price: Number(v.price), qty: 0 };
        groups[v.id].qty += 1;
      });
      var full = 0;
      var save = 0;
      Object.keys(groups).forEach(function (id) {
        var line = groups[id].price * groups[id].qty;
        full += line;
        save += Math.round(line * pct / 100);
      });
      return { full: full, save: save, net: full - save };
    }

    var wanted = Number(mount.getAttribute("data-default") || 1);
    var state = { qty: wanted >= 1 && wanted <= maxQty ? wanted : 1, rows: [] };
    var cards = [];
    var labelChanged = false;

    function seedRow() {
      var m = mainVariant();
      return {
        color: m && hasColor ? m.options[colorIndex] : null,
        size: m && hasSize ? m.options[sizeIndex] : null,
        touched: false
      };
    }
    function ensureRows() {
      while (state.rows.length < maxQty - 1) state.rows.push(seedRow());
    }
    function followMain() {
      var m = mainVariant();
      if (!m) return;
      state.rows.forEach(function (r) {
        if (r.touched) return;
        r.color = hasColor ? m.options[colorIndex] : null;
        r.size = hasSize ? m.options[sizeIndex] : null;
      });
    }
    function currentItems() {
      var m = mainVariant();
      var list = [];
      if (!m) return list;
      list.push(m);
      for (var i = 0; i < state.qty - 1; i += 1) {
        var r = state.rows[i];
        list.push((needsRows && r && variantFor(r.color, r.size)) || m);
      }
      return list;
    }
    function repeat(v, n) {
      var list = [];
      for (var i = 0; i < n; i += 1) list.push(v);
      return list;
    }

    function fillSizes(select, row) {
      var available = hasColor ? sizesFor(row.color) : sizes;
      select.innerHTML = "";
      available.forEach(function (s) {
        var option = el("option", "", s);
        option.value = s;
        select.appendChild(option);
      });
      if (available.indexOf(row.size) < 0) row.size = available.length ? available[0] : null;
      if (row.size !== null) select.value = row.size;
    }
    function buildRow(index) {
      var row = state.rows[index];
      var line = el("div", "ptb-pack__row");
      line.appendChild(el("span", "ptb-pack__n", "#" + (index + 2)));
      var colorSelect = null;
      var sizeSelect = null;
      if (hasColor) {
        var colorWrap = el("span", "ptb-pack__sel");
        colorSelect = el("select", "ptb-pack__select");
        colorSelect.setAttribute("aria-label", T.color + " #" + (index + 2));
        colors.forEach(function (c) {
          if (hasSize ? sizesFor(c).length : variantFor(c, null)) {
            var option = el("option", "", c);
            option.value = c;
            colorSelect.appendChild(option);
          }
        });
        if (row.color !== null) colorSelect.value = row.color;
        colorWrap.appendChild(colorSelect);
        line.appendChild(colorWrap);
      }
      if (hasSize) {
        var sizeWrap = el("span", "ptb-pack__sel");
        sizeSelect = el("select", "ptb-pack__select");
        sizeSelect.setAttribute("aria-label", T.size + " #" + (index + 2));
        fillSizes(sizeSelect, row);
        sizeWrap.appendChild(sizeSelect);
        line.appendChild(sizeWrap);
      }
      if (colorSelect) {
        colorSelect.addEventListener("change", function () {
          row.color = colorSelect.value;
          row.touched = true;
          if (sizeSelect) fillSizes(sizeSelect, row);
          renderPrices();
        });
      }
      if (sizeSelect) {
        sizeSelect.addEventListener("change", function () {
          row.size = sizeSelect.value;
          row.touched = true;
          renderPrices();
        });
      }
      return line;
    }
    function mainLabel() {
      var m = mainVariant();
      if (!m) return "";
      var parts = [];
      if (hasColor) parts.push(m.options[colorIndex]);
      if (hasSize) parts.push(m.options[sizeIndex]);
      return parts.join(" · ");
    }
    function renderRows() {
      cards.forEach(function (card) {
        var open = card.q === state.qty && card.q > 1 && needsRows;
        card.rows.innerHTML = "";
        card.rows.hidden = !open;
        if (!open) return;
        card.rows.appendChild(el("p", "ptb-pack__hint", hintText));
        var first = el("div", "ptb-pack__row");
        first.appendChild(el("span", "ptb-pack__n", "#1"));
        first.appendChild(el("span", "ptb-pack__fixed", mainLabel()));
        first.appendChild(el("em", "ptb-pack__note", "(" + T.mine + ")"));
        card.rows.appendChild(first);
        for (var i = 0; i < card.q - 1; i += 1) card.rows.appendChild(buildRow(i));
      });
    }
    function applyAddLabel() {
      if (!addBtn) return;
      if (state.qty >= 2) {
        var text = T.add.replace("{n}", String(state.qty));
        if (addBtn.textContent !== text) addBtn.textContent = text;
        labelChanged = true;
      } else if (labelChanged) {
        addBtn.textContent = addBtn.getAttribute("data-label-add") || addBtn.textContent;
        labelChanged = false;
      }
    }
    function renderPrices() {
      var m = mainVariant();
      cards.forEach(function (card) {
        var selected = card.q === state.qty;
        card.root.classList.toggle("is-selected", selected);
        card.radio.checked = selected;
        var list = selected ? currentItems() : (m ? repeat(m, card.q) : []);
        var t = totals(list, card.pct);
        card.net.textContent = money(t.net);
        card.full.textContent = card.pct > 0 ? money(t.full) : "";
        card.full.hidden = card.pct <= 0;
        card.save.textContent = selected && card.pct > 0 ? T.save.replace("{amount}", money(t.save)) : "";
      });
      applyAddLabel();
    }
    function choose(qty) {
      state.qty = qty;
      followMain();
      renderRows();
      renderPrices();
    }
    function onMainChange() {
      followMain();
      renderRows();
      renderPrices();
    }

    function buildCard(tier) {
      var q = tier[0];
      var pct = tier[1];
      var card = el("div", "ptb-pack__card");
      var head = el("label", "ptb-pack__head");
      var radio = document.createElement("input");
      radio.type = "radio";
      radio.name = "ptb-pack-qty";
      radio.value = String(q);
      radio.className = "ptb-pack__radio";
      var dot = el("span", "ptb-pack__dot");
      dot.setAttribute("aria-hidden", "true");
      var main = el("span", "ptb-pack__main");
      main.appendChild(el("span", "ptb-pack__title", qtyLabel(q)));
      if (pct > 0) main.appendChild(el("span", "ptb-pack__chip", "-" + pct + "%"));
      var price = el("span", "ptb-pack__price");
      var net = el("b");
      var full = el("s");
      var save = el("small", "ptb-pack__save");
      price.appendChild(net);
      price.appendChild(full);
      price.appendChild(save);
      head.appendChild(radio);
      head.appendChild(dot);
      head.appendChild(main);
      head.appendChild(price);
      card.appendChild(head);
      if (tier[2] && T[tier[2]]) card.appendChild(el("span", "ptb-pack__badge ptb-pack__badge--" + tier[2], T[tier[2]]));
      var rows = el("div", "ptb-pack__rows");
      rows.hidden = true;
      card.appendChild(rows);
      radio.addEventListener("change", function () { if (radio.checked) choose(q); });
      return { q: q, pct: pct, root: card, radio: radio, net: net, full: full, save: save, rows: rows };
    }

    var fieldset = el("fieldset", "pdp__option ptb-pack__set");
    fieldset.appendChild(el("legend", "pdp__label", T.legend));
    var list = el("div", "ptb-pack__list");
    list.setAttribute("role", "radiogroup");
    list.setAttribute("aria-label", T.legend);
    tiers.forEach(function (tier) {
      var card = buildCard(tier);
      cards.push(card);
      list.appendChild(card.root);
    });
    fieldset.appendChild(list);
    mount.appendChild(fieldset);
    var note = el("p", "ptb-pack__live");
    note.setAttribute("aria-live", "polite");
    mount.appendChild(note);

    ensureRows();
    followMain();
    renderRows();
    renderPrices();
    mount.hidden = false;
    mount.setAttribute("data-ready", "1");

    root.addEventListener("click", function (e) {
      var target = e.target;
      if (target && target.closest && target.closest("[data-ptb-color],[data-ptb-size]")) window.setTimeout(onMainChange, 0);
    });

    if (addBtn && window.MutationObserver) {
      new MutationObserver(function () { if (state.qty >= 2) applyAddLabel(); })
        .observe(addBtn, { childList: true, characterData: true, subtree: true });
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        if (state.qty < 2) return;
        var items = currentItems();
        if (items.length < 2) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var counts = {};
        var order = [];
        items.forEach(function (v) {
          if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
          counts[v.id] += 1;
        });
        var payload = order.map(function (id) { return { id: Number(id), quantity: counts[id] }; });
        note.textContent = "";
        if (addBtn) addBtn.disabled = true;
        fetch(shop + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: payload })
        })
          .then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); })
          .then(function () {
            window.location.href = (window.PTB && window.PTB.cartUrl) || (shop + "cart");
          })
          .catch(function () {
            note.textContent = T.error;
            if (addBtn) addBtn.disabled = false;
          });
      }, true);
    }
  }

  if (document.readyState === "complete") init();
  else document.addEventListener("DOMContentLoaded", init);
})();